import { useAppSelector } from "../redux/store";

export default function useCurrentUser() {
  const user = useAppSelector((state) => state.database.user);

  return user;
}
